import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const listPosts = createServerFn({ method: "GET" }).handler(async () => {
  const { fetchPosts } = await import("./db.server");
  return fetchPosts(true, 60);
});

export const getPost = createServerFn({ method: "GET" })
  .inputValidator((d: unknown) => z.object({ slug: z.string().min(1).max(120) }).parse(d))
  .handler(async ({ data }) => {
    const { fetchPost } = await import("./db.server");
    return fetchPost(data.slug, true);
  });

/** Pemicu ringan: menjalankan auto blog harian bila sudah jatuh tempo. */
export const tickAutoBlog = createServerFn({ method: "POST" }).handler(async () => {
  try {
    const { runDailyAutoBlog } = await import("./auto-blog.server");
    return await runDailyAutoBlog();
  } catch (e) {
    console.error("[auto-blog] gagal", e);
    return { ran: false as const, reason: (e as Error).message };
  }
});
